import { useMutation } from 'react-query';
import { EindomfinansAPI } from '../api';

export const useCheckProcessExists = () => {
    return useMutation(EindomfinansAPI.checkProcessExists);
};
